export default __webpack_public_path__ + "static/media/Seashell wreath1.13785126.jpg";